<template>
	<section class="container-edit">
		<div class="container-account">
			<div class="user-actions">
				<feather class="user-icon" type="user" size="60" />
				<div class="name-box">
					<h1 class="title-user">@{{ userData.usuario }}</h1>
					<div>
						<b-button class="button-user" size="is-small" type="is-primary"> Ver Avatar </b-button>
					</div>
				</div>
			</div>
		</div>
		<div class="box-info">
			<b-field grouped>
				<b-field custom-class="is-small" class="box-select-user" expanded label="Usuário">
					<b-input v-model="userData.usuario" disabled icon="account" expanded />
				</b-field>
				<b-field custom-class="is-small" class="box-select-user" expanded label="Status">
					<b-select
						v-model="userData.status"
						expanded
						disabled
						placeholder="Selecione um status"
						icon="chart-bar"
					>
						<option :value="1">Ativo</option>
						<option :value="0">Inativo</option>
					</b-select>
				</b-field>
			</b-field>
			<!--    <b-field grouped>
        <b-field
          custom-class="is-small"
          class="box-select-user"
          expanded
          label="Cargo"
        >
          <b-select
            v-model="userData.per_criausuadm"
            expanded
            disabled
            placeholder="Selecione um cargo"
            icon="shield-star-outline"
          >
            <option :value="1">
              Administrador
            </option>
            <option :value="2">
              Usuário
            </option>
            <option :value="3">
              Gestor
            </option>
          </b-select>
        </b-field>
        <b-field
          class="box-select-user"
          label="Departamento"
          expanded
          custom-class="is-small"
        >
          <b-select
            v-model="userData.departamento"
            disabled
            expanded placeholder="Selecione um departamento"
            icon="package-variant-closed"
          >
            <option :value="1">
              Gestão
            </option>
            <option :value="2">
              Vendas
            </option>
            <option :value="3">
              TI
            </option>
            <option :value="4">
              Desenvolvimento
            </option>
          </b-select>
        </b-field>
      </b-field> -->
		</div>
		<div class="roles-grapics">
			<div class="roles-title">
				<feather type="user" size="17px" />
				<h1 class="roles-user-title">Permissões</h1>
			</div>
			<div>
				<b-table :data="provisorydata">
					<b-table-column v-slot="props" field="menu" label="Tipo">
						<h1>{{ props.row.menu }}</h1>
					</b-table-column>
					<b-table-column v-slot="props" field="read" label="Status" centered>
						<b-checkbox v-model="props.row.status" disabled />
					</b-table-column>
				</b-table>
				<b-table v-if="1 != 1" :data="data">
					<b-table-column v-slot="props" field="menu" label="Menu">
						<h1>{{ props.row.menu }}</h1>
					</b-table-column>
					<b-table-column v-slot="props" field="read" label="Leitura" centered>
						<b-checkbox v-model="props.row.read" disabled />
					</b-table-column>
					<b-table-column v-slot="props" field="edit" label="Edição" centered>
						<b-checkbox v-model="props.row.edit" disabled />
					</b-table-column>
					<b-table-column v-slot="props" field="create" label="Criação" centered>
						<b-checkbox v-model="props.row.create" disabled />
					</b-table-column>
					<b-table-column v-slot="props" field="delete" label="Apagar" centered>
						<b-checkbox v-model="props.row.delete" disabled />
					</b-table-column>
				</b-table>
			</div>
		</div>
	</section>
</template>

<script>
import * as ecAxios from '../../util/ecAxios';

export default {
	data() {
		return {
			userData: {},
			name: '',
			changePassword: 'Não',
			provisorydata: [
				{
					menu: 'Permissão para alterar administradores',
					status: false,
				},
				{
					menu: 'Permissão para criar administradores',
					status: false,
				},
			],
			data: [
				{
					menu: 'pagamento',
					read: true,
					edit: false,
					create: true,
					delete: false,
				},
				{
					menu: 'usuário',
					read: false,
					edit: false,
					create: true,
					delete: false,
				},
				{
					menu: 'cartão',
					read: true,
					edit: true,
					create: false,
					delete: true,
				},
				{
					menu: 'pedidos',
					read: true,
					edit: false,
					create: true,
					delete: false,
				},
				{
					menu: 'relatórios',
					read: false,
					edit: false,
					create: true,
					delete: false,
				},
			],
		};
	},
	created() {
		this.getUser();
	},
	methods: {
		async getUser() {
			await ecAxios
				.connection()
				.get(
					`${process.env.VUE_APP_API_ADM_EC}${api.env.ADM_USUARIO_SALVAR}${this.$route.params.id}`
				)
				.then((response) => {
					if (response.data.error === 0) {
						this.userData = response.data.usuario;
						this.userData.departamento = 1;
						this.provisorydata[0].status = Boolean(this.userData.per_altusuadm);
						this.provisorydata[1].status = Boolean(this.userData.per_criausuadm);
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e,
						type: 'is-danger',
					});
				});
		},
	},
};
</script>

<style scoped>
.container-edit {
	display: flex;
	width: 100%;
	background-color: #fff;
	flex-direction: column;
	align-items: center;
	padding: 30px;
	margin-bottom: 40px;
}
.buttons-changes-bt {
	margin-top: 10px;
	margin-left: 20px;
}
.buttons-changes {
	width: 100%;
	display: flex;
	justify-content: flex-end;
}
.password-change-check {
	margin-top: 15px;
	margin-bottom: 15px;
}
.container-password {
	width: 100%;
	display: flex;
	flex-direction: row;
}
.password-rules {
	margin-bottom: 6px;
}
.box-info {
	margin-top: 20px;
}
.roles-grapics {
	width: 100%;
	padding: 10px;
	margin-top: 30px;
}
.container-account {
	width: 100%;
}
.left-side-box {
	width: 50%;
}
.right-side-box {
	width: 50%;
	padding: 10px;
}
.roles-title {
	margin-bottom: 10px;
	display: flex;
	align-items: center;
}
.roles-user-title {
	margin-left: 6px;
}
.box-info {
	width: 100%;
}
.button-user {
	margin-right: 10px;
}
.box-select-user {
	width: 50%;
	font-size: 14px;
}
.box-select-user-pass {
	width: 100%;
	font-size: 14px;
}
.user-actions {
	display: flex;
	align-items: center;
}
.user-icon {
	padding: 10px;
	margin-right: 20px;
	background-color: #0b090a17;
	border-radius: 10px;
	color: #0b090a;
}
.name-box {
	display: flex;
	flex-direction: column;
	align-self: flex-start;
}
.title-user {
	margin-bottom: 10px;
}
.title-field {
	font-size: 12px;
}
</style>

